import * as React from 'react'
import { Link, matchRoutes } from 'react-router-dom'
import PersonPinOutlinedIcon from '@mui/icons-material/PersonPinOutlined'
import { useTranslation } from 'react-i18next'
import ListItemText from '@mui/material/ListItemText'

import { useAppSelector } from 'redux/Hook'
import ListItemButton from 'components/Sidebar/Styled/Button'
import { getParticipantsRoute } from './Helper'
import ListItemIcon from 'components/Sidebar/Styled/ListItemIcon'
import bluehavenDomain from 'lib/utility/BluehavenDomain'
import { PARTICIPANT_ROUTES } from 'lib/participants/Constants'

const ParticipantLink = () => {
  const { features } = useAppSelector((state) => state.features)
  const { t } = useTranslation()

  const {
    switch_to_admin_ui: switchToAdminUI,
    switch_to_new_prm: switchToNewPRM,
  } = features

  const hasSwitchToAdminUIEnabled = switchToAdminUI?.enabled
  const hasSwitchToNewPRMEnabled = switchToNewPRM?.enabled
  const hasNewPRMSwitchedOn =
    hasSwitchToAdminUIEnabled && hasSwitchToNewPRMEnabled

  const participantLinkURL = getParticipantsRoute({
    hasNewPRMSwitchedOn,
  })

  const isParticipantRouteSelected = () => {
    if (matchRoutes(PARTICIPANT_ROUTES, location)) {
      return true
    }
    return false
  }

  const linkContent = (
    <>
      <ListItemIcon selected={isParticipantRouteSelected()}>
        <PersonPinOutlinedIcon />
      </ListItemIcon>
      <ListItemText primary={t('sidebar.participants')} />
    </>
  )

  const toNewPRMLinkComponent = (
    <ListItemButton
      to={{ pathname: participantLinkURL }}
      component={Link}
      key="participants"
      data-testid="participants"
      selected={isParticipantRouteSelected()}
    >
      {linkContent}
    </ListItemButton>
  )

  const toOldPRMLinkComponent = (
    <ListItemButton
      component="a"
      key="participants"
      selected={isParticipantRouteSelected()}
      href={`${bluehavenDomain()}${participantLinkURL}`}
    >
      {linkContent}
    </ListItemButton>
  )

  if (hasNewPRMSwitchedOn) {
    return toNewPRMLinkComponent
  }

  return toOldPRMLinkComponent
}

export default ParticipantLink
